import request from '@/utils/request'

// 0301咨询
export function query (data) {
  return request({
    url: '/query',
    method: 'post',
    data
  })
}

export function queryValue (data) {
  return request({
    url: '/query/value/get',
    method: 'post',
    data
  })
}

export function queryBuy (data) {
  return request({
    url: '/query/buy',
    method: 'post',
    data
  })
}
